module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">{{title}}</h3>\n    <div class=\"portlet-options\">\n        <span class=\"close\" ng-click=\"cancel();\">×</span>\n    </div>\n</div>\n<div class=\"modal-body\">\n    {{message}}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/errorTemplate.tpl.html
// module id = 479
// module chunks = 12